import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer'
import Moaz from './Moaz';

const Layout = () => {
  return (
    <div className='App'>
        <Navbar/>
        <Outlet/>
        <Footer/>
        <Moaz/>
    </div>
  )
}

export default Layout;